const basketballRoute = [
  {
    path: '/database/statusbarheight/:statusbarheight/sport/2/league/:leagueId', // basketball
    component: () => import('@/views/basketball/league'),
    props: true,
    children: [
      {
        path: 'schedule',
        name: 'basketball-league-schedule',
        props: true,
        component: () => import('@/views/basketball/league/schedule.vue')
      },
      {
        path: 'rank',
        name: 'basketball-league-rank',
        props: true,
        component: () => import('@/views/basketball/league/rank.vue')
      },
      {
        path: 'competition_rules',
        name: 'basketball-league-competition-rules',
        props: true,
        component: () => import('@/views/basketball/league/competitionRules.vue')
      }
    ]
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/2/cup/:cupId',
    component: () => import('@/views/basketball/cup'),
    children: [
      {
        path: 'schedule',
        name: 'basketball-cup-schedule',
        props: true,
        component: () => import('@/views/basketball/cup/schedule.vue')
      },
      {
        path: 'competition_rules',
        name: 'basketball-cup-competition-rules',
        props: true,
        component: () => import('@/views/basketball/league/competitionRules.vue')
      }
    ]
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/2/team/:teamId',
    component: () => import('@/views/basketball/team'),
    props: true,
    children: [
      {
        path: 'fixture',
        name: 'basketball-team-fixture',
        props: true,
        component: () => import('@/views/basketball/team/fixture.vue')
      },
      {
        path: 'track-record',
        name: 'basketball-team-track-record',
        props: true,
        component: () => import('@/views/basketball/team/trackRecord.vue')
      },
      {
        path: 'coach/:coachId',
        name: 'basketball-team-coach',
        props: true,
        component: () => import('@/views/basketball/team/coach.vue')
      },
      {
        path: 'player-list',
        name: 'basketball-team-player-list',
        props: true,
        component: () => import('@/views/basketball/team/playerList.vue')
      },
      {
        path: 'info', // 资料
        name: 'basketball-team-info',
        props: true,
        component: () => import('@/views/basketball/team/info.vue')
      }
    ]
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/2/player/:playerId',
    component: () => import('@/views/basketball/player'),
    props: true,
    children: [
      {
        path: 'info',
        name: 'basketball-player-info',
        props: true,
        component: () => import('@/views/basketball/player/info.vue')
      },
      {
        path: 'season-stats',
        name: 'basketball-player-seasonStats',
        props: true,
        component: () => import('@/views/basketball/player/seasonStats.vue')
      },
      {
        path: 'game-logs',
        name: 'basketball-player-gameLogs',
        props: true,
        component: () => import('@/views/basketball/player/gameLogs.vue')
      },
      {
        path: 'career-stats',
        name: 'basketball-player-careerStats',
        props: true,
        component: () => import('@/views/basketball/player/careerStats.vue')
      }
    ]
  }
]

export default basketballRoute
